export default __webpack_public_path__ + "bb1d0bd9254d6c30733eddd89be528b0.svg";